// src/features/wf3/popup/W3FinalizarValidator.jsx
import React from "react";
import s from "./W3FinalizarValidator.module.css";

// Helper local (igual ao hasText da ficha)
const normStr = (v) => (v == null ? "" : String(v));
const safeTrim = (v) => normStr(v).trim();
const hasText = (v) => safeTrim(v).length > 0;

/**
 * Recebe os dados da ficha W3 + quantidadeRealizadaNum
 * e devolve uma lista de labels de campos que ainda faltam
 * para permitir a FINALIZAÇÃO.
 */
export function validarCamposObrigatoriosFinalizar(dados, quantidadeRealizadaNum) {
  const faltando = [];

  if (!hasText(dados.previa_intervalo)) {
    faltando.push("Previsão de início do intervalo");
  }
  if (!hasText(dados.previsao_encerramento_jornada)) {
    faltando.push("Previsão de encerramento da jornada");
  }
  if (!hasText(dados.primeira_previa)) {
    faltando.push("Primeira prévia");
  }
  if (!hasText(dados.segunda_previa)) {
    faltando.push("Segunda prévia");
  }
  if (!hasText(dados.primeiro_inicio)) {
    faltando.push("Início 1");
  }
  if (!hasText(dados.primeiro_fim)) {
    faltando.push("Término 1");
  }

  // ✅ NOVA REGRA:
  // Se preencher início 2, término 2 é obrigatório
  if (hasText(dados.segundo_inicio) && !hasText(dados.segundo_fim)) {
    faltando.push("Término 2");
  }

  // Se preencher início 3, término 3 é obrigatório
  if (hasText(dados.terceiro_inicio) && !hasText(dados.terceiro_fim)) {
    faltando.push("Término 3");
  }

  // Aqui 0 é aceito como preenchido; só bloqueia se estiver null/NaN
  if (
    quantidadeRealizadaNum == null ||
    Number.isNaN(quantidadeRealizadaNum) ||
    Number(quantidadeRealizadaNum) <= 0
  ) {
    faltando.push("Quantidade realizada deve ser maior que zero");
  }

  return faltando;
}

/**
 * Modal de aviso de campos obrigatórios para FINALIZAR.
 * Props:
 * - open: boolean
 * - faltando: string[]  (lista de labels retornada pela função acima)
 * - onClose: () => void
 */
export function W3FinalizarValidatorModal({ open, faltando = [], onClose }) {
  if (!open) return null;

  const handleBackdropClick = () => {
    onClose?.();
  };

  const handleStopPropagation = (e) => {
    e.stopPropagation();
  };

  return (
    <div className={s.backdrop} onClick={handleBackdropClick}>
      <div
        className={s.modal}
        onClick={handleStopPropagation}
        role="dialog"
        aria-modal="true"
        aria-label="Campos obrigatórios para finalizar"
      >
        {/* Header verde padrão W3 */}
        <div className={s.header}>
          <div className={s.title}>Não é possível finalizar</div>
          <button
            type="button"
            className={s.close}
            aria-label="Fechar"
            onClick={onClose}
          >
            ×
          </button>
        </div>

        {/* Conteúdo */}
        <div className={s.content}>
          <div className={s.card}>
            <div className={s.row}>
              <div className={s.icon}>!</div>

              <div className={s.textBlock}>
                <p className={s.description}>
                  Para finalizar esta programação, preencha os campos abaixo:
                </p>

                <ul className={s.list}>
                  {faltando.map((campo) => (
                    <li key={campo} className={s.listItem}>
                      {campo}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Footer com botão único */}
        <div className={s.actions}>
          <button
            type="button"
            className={`${s.btn} ${s.btnPrimary}`}
            onClick={onClose}
          >
            Voltar para a ficha
          </button>
        </div>
      </div>
    </div>
  );
}
